import { Card, CardBody, CardHead } from "@/components/admin/card";
import { PageHead } from "@/components/admin/page-head";
import { Tag } from "@/components/admin/tag";
import { useBudgets } from "@/lib/finance/finance-hooks";
import { fmtFCFA } from "@/lib/format";

const MONTHS = [
	"janv.",
	"févr.",
	"mars",
	"avr.",
	"mai",
	"juin",
	"juil.",
	"août",
	"sept.",
	"oct.",
	"nov.",
	"déc.",
];

/** FIN-10 — Budgets prévisionnels (budget vs réel). */
export function AdminBudgetsPage() {
	const { data, isLoading } = useBudgets(2026);
	const rows = data ?? [];

	return (
		<>
			<PageHead
				title="Budgets prévisionnels"
				sub="Exercice 2026 · suivi budget vs réel par compte et mois"
			/>
			<Card>
				<CardHead title="Budget vs réalisé" />
				<CardBody>
					<div className="table-wrap" style={{ margin: 0 }}>
						<table className="table">
							<thead>
								<tr>
									<th>Compte</th>
									<th>Mois</th>
									<th className="right">Budget</th>
									<th className="right">Réalisé</th>
									<th className="right">Écart</th>
									<th>Statut</th>
								</tr>
							</thead>
							<tbody>
								{isLoading && (
									<tr>
										<td
											colSpan={6}
											className="muted"
											style={{ textAlign: "center", padding: 24 }}
										>
											Chargement…
										</td>
									</tr>
								)}
								{!isLoading && rows.length === 0 && (
									<tr>
										<td
											colSpan={6}
											className="muted"
											style={{ textAlign: "center", padding: 24 }}
										>
											Aucun budget saisi pour 2026. Saisie par lot via l'API{" "}
											<code>POST /budgets/batch</code>.
										</td>
									</tr>
								)}
								{rows.map((r, i) => (
									<tr key={i}>
										<td className="mono">{r.accountCode}</td>
										<td>{MONTHS[r.month - 1]}</td>
										<td className="right tn">{fmtFCFA(r.budget)}</td>
										<td className="right tn">{fmtFCFA(r.actual)}</td>
										<td className="right tn">{fmtFCFA(r.variance)}</td>
										<td>
											<Tag
												variant={r.variance >= 0 ? "success" : "danger"}
												noDot
											>
												{r.variance >= 0 ? "Dans le budget" : "Dépassement"}
											</Tag>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</CardBody>
			</Card>
		</>
	);
}
